import { PricingCard } from '@/components/pricing-card';
import { products } from '@/lib/stripe-config';
import { MobileNav } from '@/components/mobile-nav';
import { ThemeToggle } from '@/components/theme-toggle';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from '@/components/ui/carousel';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function PricingPage() {
  const navigate = useNavigate();

  // 구독 플랜과 일회성 상품 필터링
  const subscriptionPlans = products.filter(plan => plan.mode === 'subscription');


  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-background via-background to-background/80">
      <header className="sticky top-0 z-10 border-b bg-background/80 backdrop-blur-md">
        <div className="container flex h-16 items-center justify-between">
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate(-1)}
              className="mr-2 md:mr-0"
            >
              <ArrowLeft className="h-5 w-5" />
              <span className="sr-only">뒤로 가기</span>
            </Button>
            <h1 className="text-xl font-bold">요금제</h1>
          </div>
          <ThemeToggle />
        </div>
      </header>

      <main className="flex-1 pb-20">
        <div className="container space-y-12 py-12">
          <div className="mx-auto max-w-3xl space-y-4 text-center">
            <h1 className="gradient-heading text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">
              다양한 요금제로<br></br>인스타챗하세요
            </h1>
            <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
              인스타그램 ID로 만드는<br></br>인공지능 기반 대화 시뮬레이터
            </p>
          </div>

          {/* 구독 플랜 섹션 */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">

            </div>

            <div className="relative mx-auto max-w-screen-xl">
              <Carousel className="w-full relative" opts={{ loop: true }}>
                <CarouselContent>
                  {subscriptionPlans.sort((a, b) => a.price - b.price).map((plan) => (
                    <CarouselItem key={plan.priceId} className="md:basis-1/2 lg:basis-1/3 pl-4">
                      <div className="p-1">
                        <PricingCard
                          title={plan.name}
                          description={plan.description}
                          price={plan.price}
                          priceId={plan.priceId}
                          features={plan.features}
                          popular={plan.popular}
                          mode={plan.mode}
                          credits={plan.credits}
                          billingPeriod="주"
                        />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                {/* Make buttons always visible by removing hidden and md:inline-flex */}
                <CarouselPrevious className="absolute left-[-20px] top-1/2 -translate-y-1/2 z-10 h-8 w-8 rounded-full border bg-background shadow-md hover:bg-accent inline-flex" />
                <CarouselNext className="absolute right-[-20px] top-1/2 -translate-y-1/2 z-10 h-8 w-8 rounded-full border bg-background shadow-md hover:bg-accent inline-flex" />
              </Carousel>
            </div>
          </div>

          {/* 가격 정책 설명 섹션 */}
          <div className="mx-auto max-w-3xl rounded-xl border border-border/40 bg-card/50 p-6 shadow-md backdrop-blur-sm">
            <h3 className="text-lg font-medium mb-4">요금제 안내</h3>
            <div className="grid gap-4 md:grid-cols-2">
              <div className="space-y-3 text-sm text-muted-foreground">
                <p className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary"></span>
                  모든 요금은 VAT 포함가입니다.
                </p>

                <p className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary"></span>
                  매주 크레딧은 구독 갱신 시 자동으로 추가됩니다.
                </p>
              </div>
              <div className="space-y-3 text-sm text-muted-foreground">

                <p className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary"></span>
                  문의사항은 고객센터로 연락해 주세요.
                </p>
                <p className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary"></span>
                  모든 상품은 크레딧 충전 후 즉시 사용 가능합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>


      <MobileNav />
    </div>
  );
}